/* istanbul ignore file */
import { useReducedMotion as useReducedMotionFramer } from "framer-motion";

const isIE11 = !!window.MSInputMethodContext && !!(document as any).documentMode;

// Boosted useReducedMotion so that IE11 is always disabled
const useReducedMotion = () => {
    return useReducedMotionFramer() || isIE11;
};

export { useReducedMotion };
